import { useTranslation } from '@/i18n';
import { IconCaution } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';

import styles from './UnsupportedPlanWarning.module.scss';
const cx = classNames.bind(styles);

export const UnsupportedPlanWarning = () => {
  const { t } = useTranslation();
  return (
    <div className={cx(styles['container'])}>
      <IconCaution height={14} width={14} />
      {t('transaction_items.drawer.unsupported_plan')}{' '}
    </div>
  );
};
